import React from 'react';
import {
  Button,
  ButtonColor,
  ButtonSize,
  ButtonVariant,
  FormTemplate,
  SubmitButton,
  TextArea,
} from 'ui-builder';
import {
  UpdateScratchpadRequest,
  useProjectScratchpadService,
} from 'nekst-api';

import styles from './ProjectScratchpad.module.scss';

export interface EditScratchpadFormProps {
  projectId: number;
  initialText?: string;
  onCancel: () => void;
  onSaved: () => Promise<void>;
}

export function EditScratchpadForm(props: EditScratchpadFormProps) {
  const scratchpadService = useProjectScratchpadService();

  return (
    <FormTemplate<UpdateScratchpadRequest>
      submitFormFunc={async (data) => {
        await scratchpadService.update(props.projectId, data);
        return data;
      }}
      afterSubmitFunc={props.onSaved}
      initialData={{
        text: props.initialText || '',
      }}
      buttonsBlockClassName={styles.buttons}
      buttons={(
        <>
          <SubmitButton
            text="Save"
            size={ButtonSize.SMALL}
            color={ButtonColor.BLUE}
            variant={ButtonVariant.FILLED}
          />
          <Button
            text="Cancel"
            size={ButtonSize.SMALL}
            color={ButtonColor.GRAY}
            onClick={props.onCancel}
          />
        </>
      )}
    >
      <TextArea
        source="text"
        hideLabel
      />
    </FormTemplate>
  );
}
